import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea, IconButton, styled } from "@mui/material";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useAddToFavMutation } from "../../../api/menu";

const CustomIconButton = styled(IconButton)(({}) => ({
  position: "absolute",
  top: "3px",
  right: "6px",
  background: "#fff",
}));

export const LandingPageCards = ({ showMenu, menus, dishes }) => {
  let navigate = useNavigate();
  const [addToFav, { isLoading }] = useAddToFavMutation();
  console.log("dishes", dishes);
  console.log("showmeu", showMenu);
  // const data = [
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Arabian Falafel Platter Eastern Special",
  //     image: "./images/kabab1.svg",
  //     rating: "4.7",
  //     price: "40",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Arabian Kebab, Middle East Special",
  //     image: "./images/kabab2.svg",
  //     rating: "4.7",
  //     price: "50",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "lHearty Italian-Style White Bean Soup",
  //     image: "./images/kabab3.svg",
  //     rating: "4.7",
  //     price: "63",
  //   },
  //   {
  //     id: "1",
  //     title: "Arabic Cuisine",
  //     description: "Salmon with Sweet Chili Sauce (3½ to 4 ounces)",
  //     image: "./images/kabab4.svg",
  //     rating: "4.7",
  //     price: "53",
  //   },
  // ];

  const handleAddDishToFav = (id) => {
    addToFav({ id });
  };

  return (
    <>
      <Box
        sx={{
          mt: "30px",
          justifyContent: { xl: "center", sm: "center", xs: "center" },
          alignItems: { xl: "center", sm: "center", xs: "center" },
        }}
      >
        <Grid
          container
          spacing={4}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {dishes && dishes.length > 0 ? (
            <>
              {dishes?.map((v, i) => {
                return (
                  <>
                    <Grid xl={2} item lg={3} md={4} sm={6} xs={12}>
                      <Link
                        to={`/Meal_Plan/${v._id}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <Card
                          sx={{
                            maxWidth: "100%",
                            paddingBottom: {
                              lg: "12px",
                              md: "12px",
                              sm: "16px",
                              xs: "12px",
                            },
                            borderRadius: "8px",
                            borderColor: "#E1E1E6",
                            backgroundColor: "#FFFFFF",
                            height: { xl: "290px", lg: "262px" },
                            // border: "1px solid red",
                          }}
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="146px"
                              width="311px"
                              image={"/images/selectdish1.png"}
                              alt="green iguana"
                            />

                            {/* <CustomIconButton onClick={()=>handleAddDishToFav(v._id)}>
                        {false?<FavoriteBorderIcon />:<FavoriteIcon style={{color:"#E75C62"}}/>}
                      </CustomIconButton> */}
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginLeft: "12px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    // gutterBottom
                                    // variant="h5"
                                    component="div"
                                    sx={{
                                      width: "77px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      lineHeight: "16px",
                                      color: "#2B817B",
                                      // marginRight: "145.5px",
                                    }}
                                  >
                                    {v.name}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{ display: "flex", flexDirection: "row" }}
                                >
                                  <img
                                    src="/images/Star.svg"
                                    alt=""
                                    width={"13px"}
                                    height={"12.45px"}
                                  />
                                  <Typography
                                    sx={{
                                      // width: "16px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      lineHeight: "16px",
                                      paddingLeft: "9.5px",
                                    }}
                                  >
                                    {/* {v.ratings.length} */}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                fontWeight="500"
                                lineHeight="26px"
                                width="auto"
                                sx={{
                                  fontSize: {
                                    lg: "18px",
                                    md: "18px",
                                    sm: "16px",
                                    xs: "16px",
                                  },
                                }}
                                // height="52px"
                              >
                                Sweet - {v.description}.
                              </Typography>

                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <img src="./images/tag.svg" alt="" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    // width: "200px",
                                    // height: "20px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    paddingLeft: "9.69px",
                                  }}
                                >
                                  Starting from $"5" (weekly price)
                                </Typography>
                              </Box>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Link>
                    </Grid>
                  </>
                );
              })}
            </>
          ) : (
            // Static Data
            <>
              {[1, 2, 3, 4, 5, 6, 7, 8]?.map((v, i) => {
                return (
                  <>
                    <Grid xl={2} item lg={3} md={4} sm={6} xs={12}>
                      <Link
                        to={`/Meal_Plan/${v._id}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <Card
                          sx={{
                            maxWidth: "100%",
                            paddingBottom: {
                              lg: "12px",
                              md: "12px",
                              sm: "16px",
                              xs: "12px",
                            },
                            borderRadius: "8px",
                            borderColor: "#E1E1E6",
                            backgroundColor: "#FFFFFF",
                            height: { xl: "290px", lg: "262px" },
                          }}
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="146px"
                              width="311px"
                              image={"/images/selectdish1.png"}
                              alt="green iguana"
                            />

                            {/* <CustomIconButton onClick={()=>handleAddDishToFav(v._id)}>
                        {false?<FavoriteBorderIcon />:<FavoriteIcon style={{color:"#E75C62"}}/>}
                      </CustomIconButton> */}
                            <CardContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginLeft: "12px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography
                                    // gutterBottom
                                    // variant="h5"
                                    component="div"
                                    sx={{
                                      width: "77px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      lineHeight: "16px",
                                      color: "#2B817B",
                                      // marginRight: "145.5px",
                                    }}
                                  >
                                    {v.name}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{ display: "flex", flexDirection: "row" }}
                                >
                                  <img
                                    src="/images/Star.svg"
                                    alt=""
                                    width={"13px"}
                                    height={"12.45px"}
                                  />
                                  <Typography
                                    sx={{
                                      // width: "16px",
                                      // height: "16px",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      lineHeight: "16px",
                                      paddingLeft: "9.5px",
                                    }}
                                  >
                                    {/* {v.ratings.length} */}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                fontWeight="500"
                                lineHeight="26px"
                                width="auto"
                                sx={{
                                  fontSize: {
                                    lg: "18px",
                                    md: "18px",
                                    sm: "16px",
                                    xs: "16px",
                                  },
                                }}
                                // height="52px"
                              >
                                Sweet - Usually an enjoyable taste of sugar.
                              </Typography>

                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                <img src="./images/tag.svg" alt="" />
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    // width: "200px",
                                    // height: "20px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    paddingLeft: "9.69px",
                                  }}
                                >
                                  Starting from $"5" (weekly price)
                                </Typography>
                              </Box>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Link>
                    </Grid>
                  </>
                );
              })}
            </>
          )}
        </Grid>
        {showMenu && (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            mt={2}
          >
            <Button
              variant="text"
              onClick={() => {
                navigate("/allmenu");
              }}
              style={{ textDecoration: "underline", textTransform: "none" }}
            >
              See All Menu
            </Button>
          </Box>
        )}
        {/* <Box sx={{
          display:`${dispProp}`,
          flexDirection:'row',
          justifyContent:'center',
          mt:'40px'
        }}>
            <Link to="/allmenu" style={{color:'#2B817B', fontWeight:600, fontSize:'15px'}}>See All Menu</Link>
            
        </Box> */}
      </Box>
    </>
  );
};
